<template>
  <div>
    <RSnackbar
      v-if="snackbarVisible"
      :backgroundColor="snackbarColor"
      :message="snackbarText"
      :timeout="3000"
      @close="snackbarVisible = false"
    >
    </RSnackbar>
    <!-- #region NAVBAR   -->
    <nav class="bg-red-700">
      <ul class="nav-wrapper">
        <li class="icon" @click="handleGoBack()">
          <a href="#">
            <span class="tooltip">Go Back</span>
            <span><i class="fa-solid fa-arrow-left text-white ml-3"> </i></span>
          </a>
        </li>

        <li class="icon">
          <RouterLink to="/">
            <span class="tooltip">Home</span>
            <span><i class="fa-solid fa-house text-white ml-3"> </i></span
          ></RouterLink>
        </li>

        <li>
          <a href="#">
            <div class="ml-3 text-base lg:text-2xl text-white">
              {{ securityGroup.name }}
            </div>
          </a>
        </li>

        <li>
          <RouterLink to="/"></RouterLink>
        </li>
      </ul>
    </nav>

    <r-spinner v-if="loading"> </r-spinner>
    <div class="p-5" v-if="securityGroup">
      <div class="mb-3">
        <p class="text-sm text-gray-500">Security Group Name</p>
        <input
          type="text"
          v-model="securityGroup.name"
          placeholder="Security Group Name"
          maxlength="100"
          name="securityGroupName"
          id="securityGroupName"
          required
          :disabled="!enableEdit"
          class="min-h-9 width-block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
        />
      </div>

      <!-- Modules -->
      <div class="border border-gray-500 rounded-md p-5 mb-1">
        <div class="flex justify-between mb-2 border-b border-gray-500">
          <div>
            <span class="text-xl text-blue-800 mr-2">Modules:</span>
            <span>{{ `${activeModules} Active Modules` }}</span>
          </div>
          <div>
            <i
              v-if="showModules"
              class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
              @click="showModules = false"
            >
            </i>

            <i
              v-else
              class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
              @click="showModules = true"
            >
            </i>
          </div>
        </div>

        <div v-if="showModules">
          <!-- Flight Board -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !flightBoardActiveKeys.length,
                  }"
                  >Flight Board:</span
                >
                <span
                  v-on:click="enableEdit ? toggleFlightBoardItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${flightBoardActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showFlightBoardPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showFlightBoardPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showFlightBoardPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showFlightBoardPanel">
              <div class="border-b px-2 py-1">
                <label class="mr-2">
                  <input
                    class="mr-2 cursor-pointer"
                    type="radio"
                    value="option0"
                    v-model="selectedOption"
                  />
                  NO ACCESS
                </label>
                <label class="ml-2">
                  <input
                    class="mr-2 cursor-pointer"
                    type="radio"
                    value="option1"
                    v-model="selectedOption"
                  />
                  VIEW ALL FLIGHTS
                </label>
                <label class="ml-4">
                  <input
                    class="mr-2 cursor-pointer"
                    type="radio"
                    value="option2"
                    v-model="selectedOption"
                  />
                  VIEW FLIGHTS MATCHING USER GATEWAYS
                </label>
              </div>

              <div v-if="selectedOption !== 'option0'">
                <div v-for="(item, index) in flightBoardKeys" :key="index">
                  <div
                    class="flex justify-between border-b px-1 py-1"
                    v-if="item.code > 2"
                  >
                    <div
                      v-on:click="
                        enableEdit ? (item.active = !item.active) : null
                      "
                      class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                      :class="{
                        'text-red-500 line-through  bg-red-100': !item.active,
                      }"
                    >
                      {{ `${index + 1} - ${item.name}` }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Assignments Board -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !assignmentsBoardActiveKeys.length,
                  }"
                  >Assignments Board:</span
                >
                <span
                  v-on:click="enableEdit ? AssignmentsBoardItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${assignmentsBoardActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAssignmentsBoardPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAssignmentsBoardPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAssignmentsBoardPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAssignmentsBoardPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in assignmentsBoardKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Notifications -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !notificationsActiveKeys.length,
                  }"
                  >Notifications:</span
                >
                <span
                  v-on:click="enableEdit ? NotificationsItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${notificationsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showNotificationsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showNotificationsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showNotificationsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showNotificationsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in notificationsKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Bidlines -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !bidlinesActiveKeys.length,
                  }"
                  >Bidlines:</span
                >
                <span
                  v-on:click="enableEdit ? toggleBidlinesItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${bidlinesActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showBidlinesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showBidlinesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showBidlinesPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showBidlinesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in bidlinesKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Administration -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !administrationActiveKeys.length,
                  }"
                  >Administration:</span
                >
                <span
                  v-on:click="enableEdit ? toggleAdministrationItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${administrationActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAdministrationPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAdministrationPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAdministrationPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAdministrationPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in administrationKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Activity Reports -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activityReportsActiveKeys.length,
                  }"
                  >Activity Reports:</span
                >
                <span
                  v-on:click="enableEdit ? toggleActivityReportsItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${activityReportsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showActivityReportsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showActivityReportsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showActivityReportsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showActivityReportsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in activityReportsKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Security Groups -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !securityGroupsActiveKeys.length,
                  }"
                  >Security Groups:</span
                >
                <span
                  v-on:click="enableEdit ? toggleSecurityGroupsItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${securityGroupsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showSecurityGroupsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showSecurityGroupsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showSecurityGroupsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showSecurityGroupsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in securityGroupsKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Airports -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !airportsActiveKeys.length,
                  }"
                  >Airports:</span
                >
                <span
                  v-on:click="enableEdit ? toggleAirportsItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${airportsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAirportsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAirportsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAirportsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAirportsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in airportsKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Aircraft -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !aircraftActiveKeys.length,
                  }"
                  >Aircraft:</span
                >
                <span
                  v-on:click="enableEdit ? toggleAircraftItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${aircraftActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAircraftPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAircraftPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAircraftPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAircraftPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in aircraftKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Crew Requirements -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !crewRequirementsActiveKeys.length,
                  }"
                  >Crew Requirements:</span
                >
                <span
                  v-on:click="enableEdit ? toggleCrewRequirementsItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${crewRequirementsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showCrewRequirementsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showCrewRequirementsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showCrewRequirementsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showCrewRequirementsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in crewRequirementsKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Reports -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !reportsActiveKeys.length,
                  }"
                  >Reports:</span
                >
                <span
                  v-on:click="enableEdit ? toggleReportsItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${reportsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showReportsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showReportsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showReportsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showReportsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in reportsKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- My Monarch -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !myMonarchActiveKeys.length,
                  }"
                  >My Monarch:</span
                >
                <span
                  v-on:click="enableEdit ? toggleMyMonarchItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${myMonarchActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showMyMonarchPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showMyMonarchPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showMyMonarchPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showMyMonarchPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in myMonarchKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- About Monarch -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !aboutMonarchActiveKeys.length,
                  }"
                  >About Monarch:</span
                >
                <span
                  v-on:click="enableEdit ? toggleAboutMonarchItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${aboutMonarchActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAboutMonarchPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAboutMonarchPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAboutMonarchPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAboutMonarchPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in aboutMonarchKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Manuals -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !manualsActiveKeys.length,
                  }"
                  >Manuals:</span
                >
                <span
                  v-on:click="enableEdit ? toggleManualsItems : null"
                  class="cursor-pointer mr-2"
                  >{{
                    `${manualsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showManualsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showManualsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showManualsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showManualsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in manualsKeys"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="border border-gray-500 rounded-md p-5 mb-1">
        <div class="flex justify-between mb-2 border-b border-gray-500">
          <div>
            <span class="text-xl text-blue-800 mr-2">Other Authorizations</span>
          </div>
          <div>
            <i
              v-if="showOtherAuthorizations"
              class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
              @click="showOtherAuthorizations = false"
            >
            </i>

            <i
              v-else
              class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
              @click="showOtherAuthorizations = true"
            >
            </i>
          </div>
        </div>

        <div v-if="showOtherAuthorizations">
          <!-- Companies -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !activeCompanies.length,
                  }"
                  >Companies:</span
                >
                <span
                  v-on:click="enableEdit ? toggleCompaniesItems : null"
                  class="cursor-pointer mr-2"
                  >{{ `${activeCompanies.length} Active Companies` }}</span
                >
              </div>
              <div>
                <i
                  v-if="showCompaniesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showCompaniesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showCompaniesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              This list of authorized companies determines the available options
              when filtering employees and selecting a company in the employee
              profile.
            </div>
            <div v-if="showCompaniesPanel">
              <div
                class="border-b px-1 py-1"
                v-for="(item, index) in securityGroup.companies"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>

          <!-- Job Titles -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !activeJobTitles.length,
                  }"
                  >Job Titles:</span
                >
                <span
                  v-on:click="enableEdit ? toggleJobTitlesItemsL : null"
                  class="cursor-pointer mr-2"
                  >{{ `${activeJobTitles.length} Active Job Titles` }}</span
                >
              </div>

              <div>
                <i
                  v-if="showJobTitlesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showJobTitlesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showJobTitlesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              This list of authorized job titles determines the available
              options when filtering employees and selecting a job title in the
              employee profile. It also determines the "Not listed in AIMS"
              warnings shown on the Flight Board, based on the employee's job
              title.
            </div>
            <div v-if="showJobTitlesPanel">
              <div
                class="border-b px-1 py-1"
                v-for="(item, index) in securityGroup.jobTitles"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>

          <!-- Flight Assignment Cargo Roles  -->
          <div class="border border-gray-500 rounded-md p-5 mt-2 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activeFlightAssignmentCargoRoles.length,
                  }"
                  >Flight Assignments - Cargo Roles:</span
                >
                <span
                  v-on:click="
                    enableEdit ? toggleFlightAssignmentCargoRolesItems : null
                  "
                  class="cursor-pointer mr-2"
                  >{{
                    `${activeFlightAssignmentCargoRoles.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showFlightAssignmentCargoRolesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showFlightAssignmentCargoRolesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showFlightAssignmentCargoRolesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              <span
                >This list of authorized roles determines the available options
                when assigning a flight role on a "Cargo Only" type
                aircraft.</span
              >
              <span class="text-red-500 font-bold ml-2">
                Note: This list is inactive if the "Assign Flight Role" option
                is not selected.
              </span>
            </div>
            <div v-if="showFlightAssignmentCargoRolesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(
                  item, index
                ) in securityGroup.flightAssignmentCargoRoles"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Flight Assignment Passenger Roles  -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activeFlightAssignmentPassengerRoles.length,
                  }"
                  >Flight Assignments - Passenger Roles:</span
                >
                <span
                  v-on:click="
                    enableEdit
                      ? toggleFlightAssignmentPassengerRolesItems
                      : null
                  "
                  class="cursor-pointer mr-2"
                  >{{
                    `${activeFlightAssignmentPassengerRoles.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showFlightAssignmentPassengerRolesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showFlightAssignmentPassengerRolesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showFlightAssignmentPassengerRolesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              <span
                >This list of authorized roles determines the available options
                when assigning a flight role on a "Passenger" type
                aircraft.</span
              >
              <span class="text-red-500 font-bold ml-2">
                Note: This list is inactive if the "Assign Flight Role" option
                is not selected.</span
              >
            </div>
            <div v-if="showFlightAssignmentPassengerRolesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(
                  item, index
                ) in securityGroup.flightAssignmentPassengerRoles"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Ground Assignment Cargo Roles  -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activeGroundAssignmentCargoRoles.length,
                  }"
                  >Ground Assignments - Cargo Roles:</span
                >
                <span
                  @v-on:click="
                    enableEdit ? toggleGroundAssignmentCargoRolesItems : null
                  "
                  class="cursor-pointer mr-2"
                  >{{
                    `${activeGroundAssignmentCargoRoles.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showGroundAssignmentCargoRolesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showGroundAssignmentCargoRolesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showGroundAssignmentCargoRolesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              <span
                >This list of authorized roles determines the available options
                when assigning a ground role on a "Cargo Only" type
                aircraft.</span
              >
              <span class="text-red-500 font-bold ml-2">
                >Note: This list is inactive if the "Assign Ground Role" option
                is not selected.</span
              >
            </div>
            <div v-if="showGroundAssignmentCargoRolesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(
                  item, index
                ) in securityGroup.groundAssignmentCargoRoles"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Ground Assignment Passenger Roles  -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activeGroundAssignmentPassengerRoles.length,
                  }"
                  >Ground Assignments - Passenger Roles:</span
                >
                <span
                  v-on:click="
                    enableEdit
                      ? toggleGroundAssignmentPassengerRolesItems
                      : null
                  "
                  class="cursor-pointer mr-2"
                  >{{
                    `${activeGroundAssignmentPassengerRoles.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showGroundAssignmentPassengerRolesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showGroundAssignmentPassengerRolesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showGroundAssignmentPassengerRolesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              <span
                >This list of authorized roles determines the available options
                when assigning a ground role on a "Passenger" type aircraft.
              </span>
              <span class="text-red-500 font-bold ml-2">
                Note: This list is inactive if the "Assign Ground Role" option
                is not selected.</span
              >
            </div>
            <div v-if="showGroundAssignmentPassengerRolesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(
                  item, index
                ) in securityGroup.groundAssignmentPassengerRoles"
                :key="index"
              >
                <div
                  v-on:click="enableEdit ? (item.active = !item.active) : null"
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md cursor-pointer"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- End of Panels -->
      <div v-if="securityGroup._id" class="flex items-center">
        <span class="text-xs text-gray-400"
          >Group ID: {{ securityGroup._id }}</span
        >
      </div>
      <!-- Footer -->
      <div class="flex justify-between">
        <div v-if="securityGroup._id && user.securityGroup.keys.includes(606)">
          <button
            class="btn bg-red-500 text-white"
            @click="confirmDelete = true"
            v-if="!confirmDelete"
          >
            Delete Group
          </button>
          <button
            v-else
            class="btn bg-red-500 text-white"
            @click="handleDeleteSecurityGroup"
          >
            Confirm Delete
          </button>
        </div>
        <div v-else></div>

        <div class="flex justify-end">
          <button
            v-if="securityGroup._id && user.securityGroup.keys.includes(604)"
            class="btn bg-purple-500 text-white"
            @click="handleSaveSecurityGroupAs"
          >
            Save Group As
          </button>

          <button
            v-if="enableEdit"
            class="ml-1 btn bg-green-500 text-white"
            @click="handleSaveSecurityGroup"
          >
            Save Group
          </button>

          <button
            class="ml-1 btn bg-gray-500 text-white"
            @click="handleGoBack()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../services/api";
import authentication from "../services/authentication";
import { mixin } from "../mixins/mixin";
import RSnackbar from "../components/RSnackbar.vue";
import RSpinner from "../components/RSpinner.vue";

export default {
  name: "securityGroup",
  mixins: [mixin],
  components: { RSnackbar, RSpinner },
  data() {
    return {
      loading: false,

      inactivityTimer: null,
      showModules: false,
      showOtherAuthorizations: false,

      selectedOption: "option2",

      //-------------------------Snackbar
      snackbarVisible: false,
      snackbarText: "",
      snackbarColor: "white",
      snackbarTimeout: 5000,

      enableGroupToChangeEmployeeSecurityGroup: false,
      confirmDelete: false,

      showFlightBoardPanel: false,
      showAssignmentsBoardPanel: false,
      showNotificationsPanel: false,
      showBidlinesPanel: false,
      showAdministrationPanel: false,
      showActivityReportsPanel: false,
      showSecurityGroupsPanel: false,
      showAirportsPanel: false,
      showAircraftPanel: false,
      showCrewRequirementsPanel: false,
      showReportsPanel: false,
      showMyMonarchPanel: false,
      showAboutMonarchPanel: false,
      showManualsPanel: false,
      showCompaniesPanel: false,
      showJobTitlesPanel: false,
      showFlightAssignmentCargoRolesPanel: false,
      showFlightAssignmentPassengerRolesPanel: false,
      showGroundAssignmentCargoRolesPanel: false,
      showGroundAssignmentPassengerRolesPanel: false,
    };
  },

  mounted() {
    this.startInactivityTimer();
    document.addEventListener("click", this.resetInactivityTimer);
  },

  unmounted() {
    this.clearInactivityTimer();
    document.removeEventListener("click", this.resetInactivityTimer);
  },

  computed: {
    auth() {
      return this.$store.state.auth;
    },

    enableEdit() {
      return (
        this.user.securityGroup.keys.includes(604) ||
        this.user.securityGroup.keys.includes(605)
      );
    },

    securityGroup() {
      return this.$store.getters.securityGroup;
    },

    flightBoardKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Flight Board"
      );
    },
    assignmentsBoardKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Assignments Board"
      );
    },
    notificationsKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Notifications"
      );
    },
    bidlinesKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Bidlines");
    },
    administrationKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Administration"
      );
    },
    activityReportsKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Activity Reports"
      );
    },
    securityGroupsKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Security Groups"
      );
    },

    airportsKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Airports");
    },

    aircraftKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Aircraft");
    },

    crewRequirementsKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Crew Requirements"
      );
    },

    reportsKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Reports");
    },
    myMonarchKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "My Monarch"
      );
    },
    aboutMonarchKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "About Monarch"
      );
    },
    manualsKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Manuals");
    },

    activeModules() {
      const groupedByModules = Object.values(
        this.securityGroup.keys.reduce((acc, key) => {
          if (key.active) {
            if (!acc[key.module]) {
              acc[key.module] = {
                module: key.module,
                keys: [],
              };
            }
            acc[key.module].keys.push(key);
          }
          return acc;
        }, {})
      );

      return groupedByModules.length;
    },

    flightBoardActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Flight Board" && key.active && key.code > 2
      );
    },
    assignmentsBoardActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Assignments Board" && key.active
      );
    },

    notificationsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Notifications" && key.active
      );
    },
    bidlinesActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Bidlines" && key.active
      );
    },
    administrationActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Administration" && key.active
      );
    },
    activityReportsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Activity Reports" && key.active
      );
    },
    securityGroupsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Security Groups" && key.active
      );
    },
    airportsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Airports" && key.active
      );
    },
    aircraftActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Aircraft" && key.active
      );
    },
    crewRequirementsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Crew Requirements" && key.active
      );
    },
    reportsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Reports" && key.active
      );
    },
    myMonarchActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "My Monarch" && key.active
      );
    },
    aboutMonarchActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "About Monarch" && key.active
      );
    },
    manualsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Manuals" && key.active
      );
    },

    activeCompanies() {
      return this.securityGroup.companies.filter((company) => company.active);
    },
    activeJobTitles() {
      return this.securityGroup.jobTitles.filter((jobTitle) => jobTitle.active);
    },
    activeFlightAssignmentCargoRoles() {
      return this.securityGroup.flightAssignmentCargoRoles.filter(
        (role) => role.active
      );
    },
    activeFlightAssignmentPassengerRoles() {
      return this.securityGroup.flightAssignmentPassengerRoles.filter(
        (role) => role.active
      );
    },
    activeGroundAssignmentCargoRoles() {
      return this.securityGroup.groundAssignmentCargoRoles.filter(
        (role) => role.active
      );
    },

    activeGroundAssignmentPassengerRoles() {
      return this.securityGroup.groundAssignmentPassengerRoles.filter(
        (role) => role.active
      );
    },
  },

  watch: {
    securityGroup: {
      handler() {
        const code1 = this.securityGroup.keys.find((key) => key.code === 1);
        const code2 = this.securityGroup.keys.find((key) => key.code === 2);

        if (code1.active) {
          this.selectedOption = "option1";
        } else if (code2.active) {
          this.selectedOption = "option2";
        } else {
          this.selectedOption = "option0";
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    startInactivityTimer() {
      this.clearInactivityTimer();
      this.inactivityTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.timeoutDuration);
    },

    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
    },

    resetInactivityTimer() {
      this.startInactivityTimer();
    },

    async handleAutoLogout() {
      try {
        //---------------------------------------Refresh Token
        this.loading = true;
        const accessToken = await authentication.getAccessToken();
        if (!accessToken) {
          this.loading = false;
          return;
        }

        await api.get("/auth/logout", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });

        this.loading = false;

        this.$store.commit("updateAuth", null);
        this.$store.commit("updateUser", null);
        clearTimeout(this.inactivityTimer);
        this.$router.push({ name: "home" });
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarVisible = true;
        this.snackbarText = `Error during auto-logout: ${error}`;

        setTimeout(() => {
          this.$store.commit("updateAuth", null);
          this.$store.commit("updateUser", null);
          clearTimeout(this.inactivityTimer);
        }, 3000);
      }
    },

    handleGoBack() {
      this.$router.push({ name: "securityGroups" });
    },

    toggleFlightBoardItems() {
      let allActive = this.flightBoardKeys.every((key) => key.active);

      this.flightBoardKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },

    toggleAssignmentsBoardItems() {
      let allActive = this.assignmentsBoardKeys.every((key) => key.active);

      this.assignmentsBoardKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },

    toggleNotificationsItems() {
      let allActive = this.notificationsKeys.every((key) => key.active);

      this.notificationsKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleBidlinesItems() {
      let allActive = this.bidlinesKeys.every((key) => key.active);

      this.bidlinesKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleAdministrationItems() {
      let allActive = this.administrationKeys.every((key) => key.active);

      this.administrationKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleActivityReportsItems() {
      let allActive = this.activityReportsKeys.every((key) => key.active);

      this.activityReportsKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleSecurityGroupsItems() {
      let allActive = this.securityGroupsKeys.every((key) => key.active);

      this.securityGroupsKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleAirportsItems() {
      let allActive = this.airportsKeys.every((key) => key.active);

      this.airportsKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleAircraftItems() {
      let allActive = this.aircraftKeys.every((key) => key.active);

      this.aircraftKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleCrewRequirementsItems() {
      let allActive = this.crewRequirementsKeys.every((key) => key.active);

      this.crewRequirementsKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleReportsItems() {
      let allActive = this.reportsKeys.every((key) => key.active);

      this.reportsKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleMyMonarchItems() {
      let allActive = this.myMonarchKeys.every((key) => key.active);

      this.myMonarchKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleAboutMonarchItems() {
      let allActive = this.aboutMonarchKeys.every((key) => key.active);

      this.aboutMonarchKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleManualsItems() {
      let allActive = this.manualsKeys.every((key) => key.active);

      this.manualsKeys.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },

    toggleCompaniesItems() {
      let allActive = this.securityGroup.companies.every((key) => key.active);

      this.securityGroup.companies.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },

    toggleJobTitlesItems() {
      let allActive = this.securityGroup.jobTitles.every((key) => key.active);

      this.securityGroup.jobTitles.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },

    toggleFlightAssignmentCargoRolesItems() {
      let allActive = this.securityGroup.flightAssignmentCargoRoles.every(
        (key) => key.active
      );

      this.securityGroup.flightAssignmentCargoRoles.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },

    toggleFlightAssignmentPassengerRolesItems() {
      let allActive = this.securityGroup.flightAssignmentPassengerRoles.every(
        (key) => key.active
      );

      this.securityGroup.flightAssignmentPassengerRoles.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },
    toggleGroundAssignmentCargoRolesItems() {
      let allActive = this.securityGroup.groundAssignmentCargoRoles.every(
        (key) => key.active
      );

      this.securityGroup.groundAssignmentCargoRoles.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },

    toggleGroundAssignmentPassengerRolesItems() {
      let allActive = this.securityGroup.groundAssignmentPassengerRoles.every(
        (key) => key.active
      );

      this.securityGroup.groundAssignmentPassengerRoles.forEach((key) => {
        key.active = allActive ? false : true;
      });
    },

    async handleDeleteSecurityGroup() {
      if (!this.user.securityGroup.keys.includes(606)) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Not authorized. Please contact your administrator.";
        this.snackbarVisible = true;
        return;
      }

      try {
        this.loading = true;

        await api.delete(`/security-group/${this.securityGroup._id}`);

        this.loading = false;

        this.$store.commit("updateSecurityGroup", null);
        this.handleGoBack();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = `Error deleting security group: ${error}`;
        this.snackbarVisible = true;
      }
    },

    async handleSaveSecurityGroup() {
      if (
        !this.user.securityGroup.keys.includes(605) &&
        !this.user.securityGroup.keys.includes(603)
      ) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Not authorized. Please contact your administrator.";
        this.snackbarVisible = true;
        return;
      }

      if (!this.securityGroup.name) {
        this.snackbarColor = "var(--red)";
        this.snackbarText = "Please enter a name for the security group.";
        this.snackbarVisible = true;
        return;
      }
      if (this.securityGroup.name.length < 3) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Security Group name must be at least 3 characters long.";
        this.snackbarVisible = true;
        return;
      }
      if (this.securityGroup.name.length > 100) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Security Group name must be less than 100 characters long.";
        this.snackbarVisible = true;
        return;
      }

      let keys = [];

      if (this.selectedOption === "option1") {
        keys.push(1);
      } else if (this.selectedOption === "option2") {
        keys.push(2);
      }

      if (this.flightBoardActiveKeys.length) {
        keys = [...keys, ...this.flightBoardActiveKeys.map((key) => key.code)];
      }

      if (this.assignmentsBoardActiveKeys.length) {
        keys = [
          ...keys,
          ...this.assignmentsBoardActiveKeys.map((key) => key.code),
        ];
      }

      if (this.notificationsActiveKeys.length) {
        keys = [
          ...keys,
          ...this.notificationsActiveKeys.map((key) => key.code),
        ];
      }

      if (this.bidlinesActiveKeys.length) {
        keys = [...keys, ...this.bidlinesActiveKeys.map((key) => key.code)];
      }

      if (this.administrationActiveKeys.length) {
        keys = [
          ...keys,
          ...this.administrationActiveKeys.map((key) => key.code),
        ];
      }

      if (this.activityReportsActiveKeys.length) {
        keys = [
          ...keys,
          ...this.activityReportsActiveKeys.map((key) => key.code),
        ];
      }

      if (this.securityGroupsActiveKeys.length) {
        keys = [
          ...keys,
          ...this.securityGroupsActiveKeys.map((key) => key.code),
        ];
      }

      if (this.airportsActiveKeys.length) {
        keys = [...keys, ...this.airportsActiveKeys.map((key) => key.code)];
      }

      if (this.aircraftActiveKeys.length) {
        keys = [...keys, ...this.aircraftActiveKeys.map((key) => key.code)];
      }

      if (this.crewRequirementsActiveKeys.length) {
        keys = [
          ...keys,
          ...this.crewRequirementsActiveKeys.map((key) => key.code),
        ];
      }

      if (this.reportsActiveKeys.length) {
        keys = [...keys, ...this.reportsActiveKeys.map((key) => key.code)];
      }

      if (this.myMonarchActiveKeys.length) {
        keys = [...keys, ...this.myMonarchActiveKeys.map((key) => key.code)];
      }

      if (this.aboutMonarchActiveKeys.length) {
        keys = [...keys, ...this.aboutMonarchActiveKeys.map((key) => key.code)];
      }

      if (this.manualsActiveKeys.length) {
        keys = [...keys, ...this.manualsActiveKeys.map((key) => key.code)];
      }

      if (!keys.length) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Please select at least one module to save the security group.";
        this.snackbarVisible = true;
        return;
      }

      let companies = [];
      let jobTitles = [];

      if (this.activeCompanies.length) {
        companies = this.activeCompanies.map((company) => company.name);
      }

      if (this.activeJobTitles.length) {
        jobTitles = this.activeJobTitles.map((jobTitle) => jobTitle.name);
      }

      const flightAssignmentCargoRoles =
        this.activeFlightAssignmentCargoRoles.map((role) => role.name);
      const flightAssignmentPassengerRoles =
        this.activeFlightAssignmentPassengerRoles.map((role) => role.name);
      const groundAssignmentCargoRoles =
        this.activeGroundAssignmentCargoRoles.map((role) => role.name);
      const groundAssignmentPassengerRoles =
        this.activeGroundAssignmentPassengerRoles.map((role) => role.name);

      const securityGroup = {
        _id: this.securityGroup._id,
        name: this.securityGroup.name,
        companies,
        jobTitles,
        flightAssignmentCargoRoles,
        flightAssignmentPassengerRoles,
        groundAssignmentCargoRoles,
        groundAssignmentPassengerRoles,
        keys,
      };

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        let res;

        if (this.securityGroup._id) {
          res = await api.put(
            `/security-groups/${this.securityGroup._id}`,
            {
              securityGroup,
            },
            {
              headers: {
                Authorization: "Bearer " + accessToken,
              },
            }
          );
        } else {
          res = await api.post(
            `/security-groups`,
            {
              securityGroup,
            },
            {
              headers: {
                Authorization: "Bearer " + accessToken,
              },
            }
          );
        }

        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        this.handleGoBack();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    async handleSaveSecurityGroupAs() {
      if (!this.user.securityGroup.keys.includes(604)) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Not authorized. Please contact your administrator.";
        this.snackbarVisible = true;
        return;
      }

      if (!this.securityGroup.name) {
        this.snackbarColor = "var(--red)";
        this.snackbarText = "Please enter a name for the security group.";
        this.snackbarVisible = true;
        return;
      }
      if (this.securityGroup.name.length < 3) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Security Group name must be at least 3 characters long.";
        this.snackbarVisible = true;
        return;
      }
      if (this.securityGroup.name.length > 100) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Security Group name must be less than 100 characters long.";
        this.snackbarVisible = true;
        return;
      }

      let keys = [];

      if (this.selectedOption === "option1") {
        keys.push(1);
      } else if (this.selectedOption === "option2") {
        keys.push(2);
      }

      if (this.flightBoardActiveKeys.length) {
        keys = [...keys, ...this.flightBoardActiveKeys.map((key) => key.code)];
      }

      if (this.assignmentsBoardActiveKeys.length) {
        keys = [
          ...keys,
          ...this.assignmentsBoardActiveKeys.map((key) => key.code),
        ];
      }

      if (this.notificationsActiveKeys.length) {
        keys = [
          ...keys,
          ...this.notificationsActiveKeys.map((key) => key.code),
        ];
      }

      if (this.bidlinesActiveKeys.length) {
        keys = [...keys, ...this.bidlinesActiveKeys.map((key) => key.code)];
      }

      if (this.administrationActiveKeys.length) {
        keys = [
          ...keys,
          ...this.administrationActiveKeys.map((key) => key.code),
        ];
      }

      if (this.activityReportsActiveKeys.length) {
        keys = [
          ...keys,
          ...this.activityReportsActiveKeys.map((key) => key.code),
        ];
      }

      if (this.securityGroupsActiveKeys.length) {
        keys = [
          ...keys,
          ...this.securityGroupsActiveKeys.map((key) => key.code),
        ];
      }

      if (this.airportsActiveKeys.length) {
        keys = [...keys, ...this.airportsActiveKeys.map((key) => key.code)];
      }

      if (this.aircraftActiveKeys.length) {
        keys = [...keys, ...this.aircraftActiveKeys.map((key) => key.code)];
      }

      if (this.crewRequirementsActiveKeys.length) {
        keys = [
          ...keys,
          ...this.crewRequirementsActiveKeys.map((key) => key.code),
        ];
      }

      if (this.reportsActiveKeys.length) {
        keys = [...keys, ...this.reportsActiveKeys.map((key) => key.code)];
      }

      if (this.myMonarchActiveKeys.length) {
        keys = [...keys, ...this.myMonarchActiveKeys.map((key) => key.code)];
      }

      if (this.aboutMonarchActiveKeys.length) {
        keys = [...keys, ...this.aboutMonarchActiveKeys.map((key) => key.code)];
      }

      if (this.manualsActiveKeys.length) {
        keys = [...keys, ...this.manualsActiveKeys.map((key) => key.code)];
      }

      if (!keys.length) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Please select at least one module to save the security group.";
        this.snackbarVisible = true;
        return;
      }

      let companies = [];
      let jobTitles = [];

      if (this.activeCompanies.length) {
        companies = this.activeCompanies.map((company) => company.name);
      }

      if (this.activeJobTitles.length) {
        jobTitles = this.activeJobTitles.map((jobTitle) => jobTitle.name);
      }

      const flightAssignmentCargoRoles =
        this.activeFlightAssignmentCargoRoles.map((role) => role.name);
      const flightAssignmentPassengerRoles =
        this.activeFlightAssignmentPassengerRoles.map((role) => role.name);
      const groundAssignmentCargoRoles =
        this.activeGroundAssignmentCargoRoles.map((role) => role.name);
      const groundAssignmentPassengerRoles =
        this.activeGroundAssignmentPassengerRoles.map((role) => role.name);

      const securityGroup = {
        name: this.securityGroup.name,
        companies,
        jobTitles,
        flightAssignmentCargoRoles,
        flightAssignmentPassengerRoles,
        groundAssignmentCargoRoles,
        groundAssignmentPassengerRoles,
        keys,
      };

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        const res = await api.post(
          `/security-groups`,
          {
            securityGroup,
          },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        this.handleGoBack();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    async handleDeleteSecurityGroup() {
      if (!this.user.securityGroup.keys.includes(605)) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Not authorized. Please contact your administrator.";
        this.snackbarVisible = true;
        return;
      }

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        const res = await api.delete(
          `/security-groups/${this.securityGroup._id}`,
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );
        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        this.handleGoBack();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      } finally {
        this.editing = false;
        this.confirmDelete = false;
      }
    },
  },
};
</script>

<style scoped></style>
